import { useUnpersistedUserStorage } from '@office-start/user-storage-service';
import { useMemo } from 'react';
import { useUserProfileMetricsKey } from './useUserProfileMetricsKey';
export var useUserProfile = function () {
    var _a;
    var userProfileMetricsKey = useUserProfileMetricsKey();
    var unpersistedProfileMetrics = useUnpersistedUserStorage(userProfileMetricsKey);
    return useMemo(function () {
        var _a;
        return (_a = unpersistedProfileMetrics === null || unpersistedProfileMetrics === void 0 ? void 0 : unpersistedProfileMetrics.data) === null || _a === void 0 ? void 0 : _a.result;
    }, [(_a = unpersistedProfileMetrics === null || unpersistedProfileMetrics === void 0 ? void 0 : unpersistedProfileMetrics.data) === null || _a === void 0 ? void 0 : _a.result]);
};
//# sourceMappingURL=useUserProfile.js.map